import type { TEmptyAsyncCallback } from "@/shared/types/functions"

enum ECoachBreadcrumbVariant {
    Group = "group",
    Individual = "individual",
    Dashboard = "dashboard"
}

type TCoachBreadcrumb = {
    isCurrent: boolean
    url: string
    label: string
    variant: ECoachBreadcrumbVariant
    onHover?: TEmptyAsyncCallback
}

export { ECoachBreadcrumbVariant }
export type { TCoachBreadcrumb }
